import _ from 'underscore'

const syncFetchAction = ({ baseType, id, data }) => _.extend(
  {
    type: baseType.FETCH
  },
  _.isUndefined(id)
    ? {}
    : { id },
  _.isUndefined(data)
    ? {}
    : { data }
)

const syncSuccessAction = ({ baseType, id, data }) => _.extend(
  {
    type: baseType.SUCCESS
  },
  _.isUndefined(id)
    ? {}
    : { id },
  _.isUndefined(data)
    ? {}
    : { data }
)

const syncErrorAction = ({ baseType, error }) => ({
  type: baseType.ERROR,
  error
})

export const RESPONSETYPE = {
  EMPTY: 'EMPTY',
  ID: 'ID',
  IDS: 'IDS',
  DATA: 'DATA',
  FILE: 'FILE'
}

export const generateApiAction = ({ baseType, api, responseType }) => (input) => (dispatch) => {

  // Dispatch fetch sync action with api input content
  dispatch(
    syncFetchAction(
      _.extend(
        { baseType },
        _.pick(input, 'id', 'data')
      )
    )
  )

  // Call API with input
  return api(input)

  // Success callback
  .done(
    responseType === RESPONSETYPE.FILE
      ? (url) => {
          dispatch(
            syncSuccessAction({ baseType })
          )
        }
      : (data, textStatus, jqXHR) => {

          // Build output
          const output = {}
          switch (responseType) {
            case RESPONSETYPE.ID:
              _.extend(output, data)
              break;
            case RESPONSETYPE.IDS:
              _.extend(output, { id: data.ids })
              break;
            case RESPONSETYPE.DATA:
              _.extend(output, { data })
              break;
            default:
              break;
          }

          // Dispatch success sync action with api response content
          dispatch(
            syncSuccessAction(
              _.extend(
                { baseType },
                _.pick(output, 'id', 'data')
              )
            )
          )
        }
  )

  // Failure callback
  .fail(
    responseType === RESPONSETYPE.FILE
      ? (response, url) => {
          dispatch(
            syncErrorAction(
              _.extend(
                { baseType },
                {
                  error: _.pick(
                    _.extend(
                      {
                        status: 500,
                        code: null,
                        message: null
                      },
                      JSON.parse(response)
                    ),
                    'status', 'code', 'message'
                  )
                }
              )
            )
          )
        }
      : (jqXHR, textStatus, errorThrown) => {

          // Dispatch error sync action with api error content
          dispatch(
            syncErrorAction(
              _.extend(
                { baseType },
                {
                  error: _.pick(
                    _.extend(
                      {
                        status: jqXHR.status,
                        code: null,
                        message: null
                      },
                      JSON.parse(jqXHR.responseText)
                    ),
                    'status', 'code', 'message'
                  )
                }
              )
            )
          )
        }
  )
}



// WEBPACK FOOTER //
// ./src/actions/Generator.js